import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, EventEmitter, ViewEncapsulation, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@play/common';
import { CommonsComponentModule, CommonsLocationModule, SvgIconsModule, CommonsErrorModule, CommonsLoadingModule } from '@play/common';
import * as i3 from '@play/premium';
import { PremiumModule } from '@play/premium';
import * as i4 from '@play/translate';
import { TranslationModule } from '@play/translate';

function RankingContestantComponent_square_image_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "square-image", 10);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("image", ctx_r0.image);
} }
function RankingContestantComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.rank, " ");
} }
function RankingContestantComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.rank);
} }
function RankingContestantComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("- ", ctx_r3.gameaccount, "");
} }
function RankingContestantComponent_premium_badge_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "premium-badge");
} }
function RankingContestantComponent_trusted_icon_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "trusted-icon");
} }
const _c0$7 = function (a0) { return { name: a0 }; };
const _c1$2 = ["*"];
class RankingContestantComponent {
}
RankingContestantComponent.ɵfac = function RankingContestantComponent_Factory(t) { return new (t || RankingContestantComponent)(); };
RankingContestantComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingContestantComponent, selectors: [["ranking-contestant"]], inputs: { condensed: "condensed", rank: "rank", hasPremium: "hasPremium", hasTrusted: "hasTrusted", name: "name", link: "link", country: "country", image: "image", gameaccount: "gameaccount" }, ngContentSelectors: _c1$2, decls: 16, vars: 15, consts: [[1, "o-flag", "c-ranking-contestant"], [1, "o-flag__figure", "c-ranking-contestant__image"], [3, "image", 4, "ngIf"], ["class", "c-ranking-contestant__rank c-ranking-contestant__rank--condensed", 4, "ngIf"], ["class", "c-ranking-contestant__rank", 4, "ngIf"], [1, "o-flag__body"], [1, "c-ranking-contestant__wrapper"], [3, "country"], [1, "c-ranking-contestant__name", 3, "locationHref", "title", "click"], [4, "ngIf"], [3, "image"], [1, "c-ranking-contestant__rank", "c-ranking-contestant__rank--condensed"], [1, "c-ranking-contestant__rank"], [1, "c-ranking-contestant__rank__label", "c-label", "c-label--primary"]], template: function RankingContestantComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, RankingContestantComponent_square_image_2_Template, 1, 1, "square-image", 2);
        i0.ɵɵtemplate(3, RankingContestantComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(4, RankingContestantComponent_div_4_Template, 3, 1, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelement(7, "country-flag", 7);
        i0.ɵɵelementStart(8, "a", 8);
        i0.ɵɵlistener("click", function RankingContestantComponent_Template_a_click_8_listener($event) { return $event.stopPropagation(); });
        i0.ɵɵpipe(9, "translate");
        i0.ɵɵtext(10);
        i0.ɵɵtemplate(11, RankingContestantComponent_ng_container_11_Template, 2, 1, "ng-container", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, RankingContestantComponent_premium_badge_12_Template, 1, 0, "premium-badge", 9);
        i0.ɵɵtemplate(13, RankingContestantComponent_trusted_icon_13_Template, 1, 0, "trusted-icon", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div");
        i0.ɵɵprojection(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.image && !ctx.condensed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.condensed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.condensed);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("country", ctx.country);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("locationHref", ctx.link)("title", i0.ɵɵpipeBind2(9, 10, "commons:contestants-profile", i0.ɵɵpureFunction1(13, _c0$7, ctx.name)));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.name, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.gameaccount);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasPremium);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasTrusted);
    } }, directives: [i1.NgIf, i2.CountryFlagComponent, i2.LocationDirective, i2.SquareImageComponent, i3.PremiumBadgeComponent, i2.TrustedIconComponent], pipes: [i4.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingContestantComponent, [{
        type: Component,
        args: [{
                selector: "ranking-contestant",
                templateUrl: "./ranking-contestant.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { condensed: [{
            type: Input
        }], rank: [{
            type: Input
        }], hasPremium: [{
            type: Input
        }], hasTrusted: [{
            type: Input
        }], name: [{
            type: Input
        }], link: [{
            type: Input
        }], country: [{
            type: Input
        }], image: [{
            type: Input
        }], gameaccount: [{
            type: Input
        }] }); })();

const rankingContestantTexts = {
    "commons:contestants-profile": "{name}'s profile",
};

function RankingContestantSkeletonComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "div", 11);
    i0.ɵɵelementEnd();
} }
function RankingContestantSkeletonComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.rank, " ");
} }
function RankingContestantSkeletonComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "div", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.rank);
} }
class RankingContestantSkeletonComponent {
    constructor() {
        this.rank = 0;
    }
}
RankingContestantSkeletonComponent.ɵfac = function RankingContestantSkeletonComponent_Factory(t) { return new (t || RankingContestantSkeletonComponent)(); };
RankingContestantSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingContestantSkeletonComponent, selectors: [["ranking-contestant-skeleton"]], inputs: { rank: "rank", condensed: "condensed" }, decls: 13, vars: 4, consts: [[1, "o-flag", "c-ranking-contestant"], [1, "o-flag__figure", "c-ranking-contestant__image"], ["class", "c-skeleton", 4, "ngIf"], ["class", "c-ranking-contestant__rank c-ranking-contestant__rank--condensed", 4, "ngIf"], ["class", "c-ranking-contestant__rank", 4, "ngIf"], [1, "o-flag__body"], [1, "c-ranking-contestant__wrapper"], [3, "country"], [1, "c-ranking-contestant__name", "c-skeleton__text", "c-skeleton__text--inline", "c-skeleton__text--smaller"], [1, "c-skeleton__text", "c-skeleton__text--inline", "c-skeleton__text--smaller"], [1, "c-skeleton"], [1, "c-skeleton__figure", "u-shape-rounded-square", "o-ratio", "o-ratio--1:1"], [1, "c-ranking-contestant__rank", "c-ranking-contestant__rank--condensed"], [1, "c-ranking-contestant__rank"], [1, "c-ranking-contestant__rank__label", "c-label", "c-label--primary"]], template: function RankingContestantSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, RankingContestantSkeletonComponent_div_2_Template, 2, 0, "div", 2);
        i0.ɵɵtemplate(3, RankingContestantSkeletonComponent_div_3_Template, 2, 1, "div", 3);
        i0.ɵɵtemplate(4, RankingContestantSkeletonComponent_div_4_Template, 3, 1, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelement(7, "country-flag", 7);
        i0.ɵɵelement(8, "div", 8);
        i0.ɵɵelement(9, "premium-icon");
        i0.ɵɵelement(10, "trusted-icon");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div");
        i0.ɵɵelement(12, "div", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.condensed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.condensed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.condensed);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("country", null);
    } }, directives: [i1.NgIf, i2.CountryFlagComponent, i2.PremiumIconComponent, i2.TrustedIconComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingContestantSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "ranking-contestant-skeleton",
                templateUrl: "./ranking-contestant-skeleton.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { rank: [{
            type: Input
        }], condensed: [{
            type: Input
        }] }); })();

class RankingMemberEntrySkeletonComponent {
}
RankingMemberEntrySkeletonComponent.ɵfac = function RankingMemberEntrySkeletonComponent_Factory(t) { return new (t || RankingMemberEntrySkeletonComponent)(); };
RankingMemberEntrySkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingMemberEntrySkeletonComponent, selectors: [["ranking-member-entry-skeleton"]], decls: 12, vars: 1, consts: [[1, "o-flag", "c-ranking-member-entry"], [1, "o-flag__figure", "c-ranking-member-entry__image"], [1, "c-skeleton"], [1, "c-skeleton__figure", "u-shape-rounded-square", "o-ratio", "o-ratio--1:1"], [1, "o-flag__body"], [1, "c-ranking-member-entry__wrapper"], [3, "country"], [1, "c-ranking-member-entry__name", "c-skeleton__text", "c-skeleton__text--inline", "c-skeleton__text--smaller"], [1, "c-skeleton__text", "c-skeleton__text--inline", "c-skeleton__text--smaller"]], template: function RankingMemberEntrySkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelement(6, "country-flag", 6);
        i0.ɵɵelement(7, "div", 7);
        i0.ɵɵelement(8, "premium-icon");
        i0.ɵɵelement(9, "trusted-icon");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div");
        i0.ɵɵelement(11, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("country", "null");
    } }, directives: [i2.CountryFlagComponent, i2.PremiumIconComponent, i2.TrustedIconComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingMemberEntrySkeletonComponent, [{
        type: Component,
        args: [{
                selector: "ranking-member-entry-skeleton",
                templateUrl: "./ranking-member-entry-skeleton.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

function RankingMembersSkeletonComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "ranking-member-entry-skeleton");
    i0.ɵɵelementEnd();
} }
class RankingMembersSkeletonComponent {
    constructor() {
        this.count = null;
    }
    ngOnInit() {
        this.members = this.getMembers();
    }
    /**
     * Get the amount of members that should be rendered
     */
    getMembers() {
        const count = this.count !== null ? this.count : 4;
        return new Array(count);
    }
    trackMember(index, item) {
        return index;
    }
}
RankingMembersSkeletonComponent.ɵfac = function RankingMembersSkeletonComponent_Factory(t) { return new (t || RankingMembersSkeletonComponent)(); };
RankingMembersSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingMembersSkeletonComponent, selectors: [["ranking-members-skeleton"]], inputs: { count: "count" }, decls: 6, vars: 5, consts: [[1, "c-ranking-members"], [1, "c-ranking-members__title"], [1, "o-grid", "o-grid--inside", "c-ranking-members__member-list"], ["class", "o-grid__item u-1/2", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "o-grid__item", "u-1/2"]], template: function RankingMembersSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, RankingMembersSkeletonComponent_div_5_Template, 2, 0, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "commons:members"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.members)("ngForTrackBy", ctx.trackMember);
    } }, directives: [i1.NgForOf, RankingMemberEntrySkeletonComponent], pipes: [i4.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingMembersSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "ranking-members-skeleton",
                templateUrl: "./ranking-members-skeleton.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { count: [{
            type: Input
        }] }); })();

function RankingMemberEntryComponent_square_image_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "square-image", 9);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("image", ctx_r0.image);
} }
function RankingMemberEntryComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.gameaccount);
} }
function RankingMemberEntryComponent_premium_badge_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "premium-badge");
} }
function RankingMemberEntryComponent_trusted_icon_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "trusted-icon");
} }
const _c0$6 = function (a0) { return { name: a0 }; };
const _c1$1 = ["*"];
class RankingMemberEntryComponent {
}
RankingMemberEntryComponent.ɵfac = function RankingMemberEntryComponent_Factory(t) { return new (t || RankingMemberEntryComponent)(); };
RankingMemberEntryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingMemberEntryComponent, selectors: [["ranking-member-entry"]], inputs: { hasPremium: "hasPremium", hasTrusted: "hasTrusted", name: "name", link: "link", country: "country", image: "image", gameaccount: "gameaccount" }, ngContentSelectors: _c1$1, decls: 14, vars: 13, consts: [[1, "o-flag", "c-ranking-member-entry"], [1, "o-flag__figure", "c-ranking-member-entry__image"], [3, "image", 4, "ngIf"], [1, "o-flag__body"], [1, "c-ranking-member-entry__wrapper"], [3, "country"], [1, "c-ranking-member-entry__name", 3, "locationHref", "title"], ["class", "c-ranking-contestant__gameaccount", 4, "ngIf"], [4, "ngIf"], [3, "image"], [1, "c-ranking-contestant__gameaccount"]], template: function RankingMemberEntryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, RankingMemberEntryComponent_square_image_2_Template, 1, 1, "square-image", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelement(5, "country-flag", 5);
        i0.ɵɵelementStart(6, "a", 6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, RankingMemberEntryComponent_span_9_Template, 2, 1, "span", 7);
        i0.ɵɵtemplate(10, RankingMemberEntryComponent_premium_badge_10_Template, 1, 0, "premium-badge", 8);
        i0.ɵɵtemplate(11, RankingMemberEntryComponent_trusted_icon_11_Template, 1, 0, "trusted-icon", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div");
        i0.ɵɵprojection(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.image);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("country", ctx.country);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("locationHref", ctx.link)("title", i0.ɵɵpipeBind2(7, 8, "commons:contestants-profile", i0.ɵɵpureFunction1(11, _c0$6, ctx.name)));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.name, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.gameaccount);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasPremium);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasTrusted);
    } }, directives: [i1.NgIf, i2.CountryFlagComponent, i2.LocationDirective, i2.SquareImageComponent, i3.PremiumBadgeComponent, i2.TrustedIconComponent], pipes: [i4.TranslatePipe], styles: ["[_nghost-%COMP%] {\n                display: block;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingMemberEntryComponent, [{
        type: Component,
        args: [{
                selector: "ranking-member-entry",
                templateUrl: "./ranking-member-entry.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [
                    `
            :host {
                display: block;
            }
        `,
                ],
            }]
    }], null, { hasPremium: [{
            type: Input
        }], hasTrusted: [{
            type: Input
        }], name: [{
            type: Input
        }], link: [{
            type: Input
        }], country: [{
            type: Input
        }], image: [{
            type: Input
        }], gameaccount: [{
            type: Input
        }] }); })();

function RankingMembersComponent_div_5_ranking_member_entry_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ranking-member-entry", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const member_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("hasPremium", member_r1.hasPremium)("hasTrusted", member_r1.hasTrusted)("name", member_r1.name)("country", member_r1.country)("image", member_r1.image)("link", member_r1.link)("gameaccount", member_r1.gameaccount);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(member_r1.appendix);
} }
function RankingMembersComponent_div_5_ranking_member_entry_skeleton_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ranking-member-entry-skeleton");
} }
function RankingMembersComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, RankingMembersComponent_div_5_ranking_member_entry_1_Template, 2, 8, "ranking-member-entry", 5);
    i0.ɵɵtemplate(2, RankingMembersComponent_div_5_ranking_member_entry_skeleton_2_Template, 1, 0, "ranking-member-entry-skeleton", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const member_r1 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", member_r1.name);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !member_r1.name);
} }
class RankingMembersComponent {
    trackMember(index, member) {
        return member.id;
    }
}
RankingMembersComponent.ɵfac = function RankingMembersComponent_Factory(t) { return new (t || RankingMembersComponent)(); };
RankingMembersComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingMembersComponent, selectors: [["ranking-members"]], inputs: { members: "members" }, decls: 6, vars: 5, consts: [[1, "c-ranking-members"], [1, "c-ranking-members__title"], [1, "o-grid", "o-grid--inside", "c-ranking-members__member-list"], ["class", "o-grid__item u-1/2", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "o-grid__item", "u-1/2"], [3, "hasPremium", "hasTrusted", "name", "country", "image", "link", "gameaccount", 4, "ngIf"], [4, "ngIf"], [3, "hasPremium", "hasTrusted", "name", "country", "image", "link", "gameaccount"]], template: function RankingMembersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, RankingMembersComponent_div_5_Template, 3, 2, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "commons:members"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.members)("ngForTrackBy", ctx.trackMember);
    } }, directives: [i1.NgForOf, i1.NgIf, RankingMemberEntryComponent, RankingMemberEntrySkeletonComponent], pipes: [i4.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingMembersComponent, [{
        type: Component,
        args: [{
                selector: "ranking-members",
                templateUrl: "./ranking-members.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { members: [{
            type: Input
        }] }); })();

function RankingEntryComponent_ranking_contestant_3_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("locationHref", ctx_r3.contestant.homepage);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.contestant.homepage, " ");
} }
function RankingEntryComponent_ranking_contestant_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ranking-contestant", 6);
    i0.ɵɵtemplate(1, RankingEntryComponent_ranking_contestant_3_a_1_Template, 2, 2, "a", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hasPremium", ctx_r0.contestant.hasPremium)("hasTrusted", ctx_r0.contestant.hasTrusted)("rank", ctx_r0.contestant.rank)("name", ctx_r0.contestant.name)("country", ctx_r0.contestant.country)("image", ctx_r0.contestant.image)("link", ctx_r0.contestant.link)("condensed", !ctx_r0.contestant.rank || ctx_r0.contestant.rank > 3)("gameaccount", ctx_r0.contestant.gameaccount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.contestant.rank < 11);
} }
function RankingEntryComponent_ranking_contestant_skeleton_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ranking-contestant-skeleton", 9);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("rank", ctx_r1.contestant.rank)("condensed", !ctx_r1.contestant.rank || ctx_r1.contestant.rank > 3);
} }
function RankingEntryComponent_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function RankingEntryComponent_ng_container_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ranking-members-skeleton", 14);
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("count", ctx_r6.members.entry.rosterCount);
} }
function RankingEntryComponent_ng_container_6_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ranking-members", 15);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("members", ctx_r8.members.entry.members);
} }
function RankingEntryComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 10);
    i0.ɵɵtemplate(1, RankingEntryComponent_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵtemplate(2, RankingEntryComponent_ng_container_6_ng_template_2_Template, 1, 1, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, RankingEntryComponent_ng_container_6_ng_template_4_Template, 1, 1, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r5 = i0.ɵɵreference(3);
    const _r7 = i0.ɵɵreference(5);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.members.loading)("ngIfThen", _r5)("ngIfElse", _r7);
} }
const _c0$5 = ["*"];
class RankingEntryComponent {
    constructor() {
        this.expansionChanged = new EventEmitter();
        this.expandable = true;
    }
    isArray(val) {
        return Array.isArray(val);
    }
}
RankingEntryComponent.ɵfac = function RankingEntryComponent_Factory(t) { return new (t || RankingEntryComponent)(); };
RankingEntryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingEntryComponent, selectors: [["ranking-entry"]], inputs: { isExpanded: "isExpanded", members: "members", contestant: "contestant", expandable: "expandable" }, outputs: { expansionChanged: "expansionChanged" }, ngContentSelectors: _c0$5, decls: 7, vars: 8, consts: [[3, "expand", "condensed", "expandable", "expansionChanged"], ["expansion-panel-header", "", 1, "o-grid", "o-grid--align-center", "o-grid--inside"], [1, "o-grid__item", "u-1/2"], [3, "hasPremium", "hasTrusted", "rank", "name", "country", "image", "link", "condensed", "gameaccount", 4, "ngIf"], [3, "rank", "condensed", 4, "ngIf"], ["expansion-panel-panel", "", 4, "ngIf"], [3, "hasPremium", "hasTrusted", "rank", "name", "country", "image", "link", "condensed", "gameaccount"], ["target", "_blank", 3, "locationHref", 4, "ngIf"], ["target", "_blank", 3, "locationHref"], [3, "rank", "condensed"], ["expansion-panel-panel", ""], [4, "ngIf", "ngIfThen", "ngIfElse"], ["loading", ""], ["notLoading", ""], [3, "count"], [3, "members"]], template: function RankingEntryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "expansion-panel", 0);
        i0.ɵɵlistener("expansionChanged", function RankingEntryComponent_Template_expansion_panel_expansionChanged_0_listener($event) { return ctx.expansionChanged.emit($event); });
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, RankingEntryComponent_ranking_contestant_3_Template, 2, 10, "ranking-contestant", 3);
        i0.ɵɵtemplate(4, RankingEntryComponent_ranking_contestant_skeleton_4_Template, 1, 2, "ranking-contestant-skeleton", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, RankingEntryComponent_ng_container_6_Template, 6, 3, "ng-container", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("expand", ctx.isExpanded)("condensed", ctx.contestant.rank > 3)("expandable", ctx.expandable);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("o-grid--auto", ctx.isArray(ctx.contestant.tiebreaker));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.contestant.name);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.contestant.name);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.members);
    } }, directives: [i2.ExpansionPanelComponent, i1.NgIf, RankingContestantComponent, i2.LocationDirective, RankingContestantSkeletonComponent, RankingMembersSkeletonComponent, RankingMembersComponent], styles: ["[_nghost-%COMP%] {\n                display: block;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingEntryComponent, [{
        type: Component,
        args: [{
                selector: "ranking-entry",
                templateUrl: "./ranking-entry.component.html",
                encapsulation: ViewEncapsulation.Emulated,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [
                    `
            :host {
                display: block;
            }
        `,
                ],
            }]
    }], null, { isExpanded: [{
            type: Input
        }], members: [{
            type: Input
        }], contestant: [{
            type: Input
        }], expansionChanged: [{
            type: Output
        }], expandable: [{
            type: Input
        }] }); })();

const _c0$4 = function (a0) { return { "c-ranking-group-picker__group--selected": a0 }; };
function RankingGroupPickerComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "button", 4);
    i0.ɵɵlistener("click", function RankingGroupPickerComponent_div_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const group_r1 = ctx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.picked.emit(group_r1); });
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0$4, group_r1 === ctx_r0.selectedGroup));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", group_r1 + 1, " ");
} }
class RankingGroupPickerComponent {
    constructor() {
        this.picked = new EventEmitter();
    }
    trackGroup(index, item) {
        return item;
    }
}
RankingGroupPickerComponent.ɵfac = function RankingGroupPickerComponent_Factory(t) { return new (t || RankingGroupPickerComponent)(); };
RankingGroupPickerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingGroupPickerComponent, selectors: [["ranking-group-picker"]], inputs: { groups: "groups", selectedGroup: "selectedGroup", playerGroup: "playerGroup" }, outputs: { picked: "picked" }, decls: 6, vars: 5, consts: [[1, "c-ranking-group-picker", "u-baseline", "o-grid", "o-grid--inside"], [1, "o-grid__item", "u-1/1"], ["class", "o-grid__item u-1/6 u-baseline-smaller", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "o-grid__item", "u-1/6", "u-baseline-smaller"], [1, "c-ranking-group-picker__group", 3, "ngClass", "click"], [1, "c-media-box", "o-ratio", "o-ratio--1:1"], [1, "c-media-box__media", "c-ranking-group-picker__group__number"]], template: function RankingGroupPickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h3");
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, RankingGroupPickerComponent_div_5_Template, 5, 4, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "ranking-group-picker:pick-group"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.groups)("ngForTrackBy", ctx.trackGroup);
    } }, directives: [i1.NgForOf, i1.NgClass], pipes: [i4.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingGroupPickerComponent, [{
        type: Component,
        args: [{
                selector: "ranking-group-picker",
                templateUrl: "./ranking-group-picker.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { groups: [{
            type: Input
        }], selectedGroup: [{
            type: Input
        }], playerGroup: [{
            type: Input
        }], picked: [{
            type: Output
        }] }); })();

const rankingGroupPickerTexts = {
    "ranking-group-picker:pick-group": "Pick Group",
};

function RankingMatchComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "button", 8);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 9);
    i0.ɵɵelement(4, "path", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 11);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(13, "svg", 9);
    i0.ɵɵelement(14, "path", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 4, "commons:enter-result-description"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "commons:enter-result"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(9, 8, "commons:protest-match-description"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 10, "commons:protest-match"));
} }
const _c0$3 = function (a0) { return { "c-ranking-match--active": a0 }; };
const _c1 = ["*"];
class RankingMatchComponent {
}
RankingMatchComponent.ɵfac = function RankingMatchComponent_Factory(t) { return new (t || RankingMatchComponent)(); };
RankingMatchComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingMatchComponent, selectors: [["ranking-match"]], inputs: { link: "link", startTime: "startTime", state: "state", active: "active", withActions: "withActions" }, ngContentSelectors: _c1, decls: 9, vars: 7, consts: [[1, "c-ranking-match", 3, "ngClass"], [1, "c-ranking-match__body", 3, "locationHref"], [1, "c-ranking-match__time"], [3, "date"], [1, "c-ranking-match__title"], [1, "c-ranking-match__state"], ["class", "c-ranking-match__footer", 4, "ngIf"], [1, "c-ranking-match__footer"], ["disabled", "", 1, "c-ranking-match__action", "u-color-primary", 3, "title"], ["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 1, "c-ranking-match__action__icon"], ["d", "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"], ["disabled", "", 1, "c-ranking-match__action", "u-color-failure", 3, "title"], ["d", "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"]], template: function RankingMatchComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "a", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "format-date", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵprojection(5);
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, RankingMatchComponent_div_8_Template, 15, 12, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0$3, ctx.active));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("locationHref", ctx.link);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("date", ctx.startTime);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("\u2014 ", ctx.state, "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.withActions);
    } }, directives: [i1.NgClass, i2.LocationDirective, i2.FormatDateComponent, i1.NgIf], pipes: [i4.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingMatchComponent, [{
        type: Component,
        args: [{
                selector: "ranking-match",
                templateUrl: "./ranking-match.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { link: [{
            type: Input
        }], startTime: [{
            type: Input
        }], state: [{
            type: Input
        }], active: [{
            type: Input
        }], withActions: [{
            type: Input
        }] }); })();

const rankingMatchTexts = {
    "commons:enter-result": "enter",
    "commons:enter-result-description": "Enter the final score of the match.",
    "commons:protest-match": "protest",
    "commons:protest-match-description": "Protest a match to report a rule violation.",
};

const rankingMemberEntryTexts = {
    "commons:contestants-profile": "{name}'s profile",
};

const rankingMembersText = {
    "commons:members": "members",
};

class RankingNotStartedComponent {
}
RankingNotStartedComponent.ɵfac = function RankingNotStartedComponent_Factory(t) { return new (t || RankingNotStartedComponent)(); };
RankingNotStartedComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingNotStartedComponent, selectors: [["ranking-not-started"]], decls: 3, vars: 3, consts: [[1, "c-ranking-not-started"]], template: function RankingNotStartedComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "ranking-not-started:not-started-yet"), "\n");
    } }, pipes: [i4.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingNotStartedComponent, [{
        type: Component,
        args: [{
                selector: "ranking-not-started",
                templateUrl: "./ranking-not-started.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

const rankingNotStartedTexts = {
    "ranking-not-started:not-started-yet": "Tournament has not started yet, please come back later!",
};

const _c0$2 = function (a0) { return { "c-ranking-round-picker__round--selected": a0 }; };
function RankingRoundPickerComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "button", 4);
    i0.ɵɵlistener("click", function RankingRoundPickerComponent_div_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const round_r1 = ctx.$implicit; const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.picked.emit(round_r1); });
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵelementStart(3, "div", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const round_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$2, round_r1 === ctx_r0.selectedRound))("disabled", ctx_r0.currentRound < round_r1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", round_r1, " ");
} }
class RankingRoundPickerComponent {
    constructor() {
        this.picked = new EventEmitter();
    }
}
RankingRoundPickerComponent.ɵfac = function RankingRoundPickerComponent_Factory(t) { return new (t || RankingRoundPickerComponent)(); };
RankingRoundPickerComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingRoundPickerComponent, selectors: [["ranking-round-picker"]], inputs: { rounds: "rounds", selectedRound: "selectedRound", currentRound: "currentRound" }, outputs: { picked: "picked" }, decls: 6, vars: 4, consts: [[1, "c-ranking-round-picker", "u-baseline", "o-grid", "o-grid--inside"], [1, "o-grid__item", "u-1/1"], ["class", "o-grid__item u-1/5 u-baseline-smaller", 4, "ngFor", "ngForOf"], [1, "o-grid__item", "u-1/5", "u-baseline-smaller"], [1, "c-ranking-round-picker__round", 3, "ngClass", "disabled", "click"], [1, "c-media-box", "o-ratio", "o-ratio--1:1"], [1, "c-media-box__media", "c-ranking-round-picker__round__number"]], template: function RankingRoundPickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h3");
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, RankingRoundPickerComponent_div_5_Template, 5, 5, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "ranking-round-picker:pick-round"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.rounds);
    } }, directives: [i1.NgForOf, i1.NgClass], pipes: [i4.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingRoundPickerComponent, [{
        type: Component,
        args: [{
                selector: "ranking-round-picker",
                templateUrl: "./ranking-round-picker.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { rounds: [{
            type: Input
        }], selectedRound: [{
            type: Input
        }], currentRound: [{
            type: Input
        }], picked: [{
            type: Output
        }] }); })();

const rankingRoundPickerTexts = {
    "ranking-round-picker:pick-round": "Pick Round",
    "ranking-round-picker:current-round": "current",
};

const _c0$1 = ["*"];
class RankingSwitcherComponent {
    constructor() {
        this.page = 0;
        this.switch = new EventEmitter();
        this.paginated = new EventEmitter();
    }
    goBack() {
        if (!this.canGoBack) {
            return;
        }
        this.page--;
        this.paginated.emit(this.page);
    }
    goNext() {
        if (!this.canGoNext) {
            return;
        }
        this.page++;
        this.paginated.emit(this.page);
    }
    get canGoNext() {
        return this.page < this.max;
    }
    get canGoBack() {
        return this.page > 0;
    }
}
RankingSwitcherComponent.ɵfac = function RankingSwitcherComponent_Factory(t) { return new (t || RankingSwitcherComponent)(); };
RankingSwitcherComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingSwitcherComponent, selectors: [["ranking-switcher"]], inputs: { page: "page", max: "max" }, outputs: { switch: "switch", paginated: "paginated" }, ngContentSelectors: _c0$1, decls: 7, vars: 12, consts: [[1, "c-ranking-switcher"], [1, "c-button", "c-ranking-switcher__control", "c-ranking-switcher__control--previous", 3, "disabled", "click"], [3, "icon"], [1, "c-button", "c-ranking-switcher__control", "c-ranking-switcher__control--inner", 3, "click"], [1, "c-button", "c-ranking-switcher__control", "c-ranking-switcher__control--next", 3, "disabled", "click"]], template: function RankingSwitcherComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "button", 1);
        i0.ɵɵlistener("click", function RankingSwitcherComponent_Template_button_click_1_listener() { return ctx.goBack(); });
        i0.ɵɵelement(2, "svg-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function RankingSwitcherComponent_Template_button_click_3_listener() { return ctx.switch.emit(); });
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "button", 4);
        i0.ɵɵlistener("click", function RankingSwitcherComponent_Template_button_click_5_listener() { return ctx.goNext(); });
        i0.ɵɵelement(6, "svg-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", !ctx.canGoBack);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("width", 24, "px")("height", 24, "px");
        i0.ɵɵproperty("icon", "chevron-left");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", !ctx.canGoNext);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("width", 24, "px")("height", 24, "px");
        i0.ɵɵproperty("icon", "chevron-right");
    } }, directives: [i2.SvgIconComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingSwitcherComponent, [{
        type: Component,
        args: [{
                selector: "ranking-switcher",
                templateUrl: "./ranking-switcher.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { page: [{
            type: Input
        }], max: [{
            type: Input
        }], switch: [{
            type: Output
        }], paginated: [{
            type: Output
        }] }); })();

const rankingSwitcherTexts = {};

class RankingSwitcherSkeletonComponent {
}
RankingSwitcherSkeletonComponent.ɵfac = function RankingSwitcherSkeletonComponent_Factory(t) { return new (t || RankingSwitcherSkeletonComponent)(); };
RankingSwitcherSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingSwitcherSkeletonComponent, selectors: [["ranking-switcher-skeleton"]], decls: 7, vars: 12, consts: [[1, "c-ranking-switcher"], [1, "c-button", "c-ranking-switcher__control", "c-ranking-switcher__control--previous", 3, "disabled"], [3, "icon"], [1, "c-button", "c-ranking-switcher__control", "c-ranking-switcher__control--inner"], [1, "c-skeleton__text"], [1, "c-button", "c-ranking-switcher__control", "c-ranking-switcher__control--next", 3, "disabled"]], template: function RankingSwitcherSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "button", 1);
        i0.ɵɵelement(2, "svg-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "button", 5);
        i0.ɵɵelement(6, "svg-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("disabled", true);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("width", 24, "px")("height", 24, "px");
        i0.ɵɵproperty("icon", "chevron-left");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", true);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("width", 24, "px")("height", 24, "px");
        i0.ɵɵproperty("icon", "chevron-right");
    } }, directives: [i2.SvgIconComponent], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingSwitcherSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "ranking-switcher-skeleton",
                templateUrl: "./ranking-switcher-skeleton.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

function RankingMatchSkeletonComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "button", 7);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 8);
    i0.ɵɵelement(4, "path", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 10);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementStart(10, "span");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(13, "svg", 8);
    i0.ɵɵelement(14, "path", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 4, "commons:enter-result-description"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "commons:enter-result"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(9, 8, "commons:protest-match-description"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 10, "commons:protest-match"));
} }
const _c0 = ["*"];
class RankingMatchSkeletonComponent {
}
RankingMatchSkeletonComponent.ɵfac = function RankingMatchSkeletonComponent_Factory(t) { return new (t || RankingMatchSkeletonComponent)(); };
RankingMatchSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RankingMatchSkeletonComponent, selectors: [["ranking-match-skeleton"]], inputs: { withActions: "withActions" }, ngContentSelectors: _c0, decls: 7, vars: 1, consts: [[1, "c-ranking-match"], [1, "c-ranking-match__body"], [1, "c-ranking-match__time"], [1, "c-skeleton__text"], [1, "c-ranking-match__title"], ["class", "c-ranking-match__footer", 4, "ngIf"], [1, "c-ranking-match__footer"], ["disabled", "", 1, "c-ranking-match__action", "u-color-primary", 3, "title"], ["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 1, "c-ranking-match__action__icon"], ["d", "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"], ["disabled", "", 1, "c-ranking-match__action", "u-color-failure", 3, "title"], ["d", "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"]], template: function RankingMatchSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵprojection(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, RankingMatchSkeletonComponent_div_6_Template, 15, 12, "div", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.withActions);
    } }, directives: [i1.NgIf], pipes: [i4.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingMatchSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "ranking-match-skeleton",
                templateUrl: "./ranking-match-skeleton.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { withActions: [{
            type: Input
        }] }); })();

class RankingComponentsModule {
}
RankingComponentsModule.ɵfac = function RankingComponentsModule_Factory(t) { return new (t || RankingComponentsModule)(); };
RankingComponentsModule.ɵmod = i0.ɵɵdefineNgModule({ type: RankingComponentsModule });
RankingComponentsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, CommonsComponentModule, CommonsLocationModule, TranslationModule, PremiumModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RankingComponentsModule, { declarations: [RankingMemberEntryComponent,
        RankingMembersComponent,
        RankingContestantComponent,
        RankingRoundPickerComponent,
        RankingGroupPickerComponent,
        RankingMatchComponent,
        RankingSwitcherComponent,
        RankingMatchSkeletonComponent,
        RankingMemberEntrySkeletonComponent,
        RankingContestantSkeletonComponent,
        RankingMembersSkeletonComponent,
        RankingSwitcherSkeletonComponent,
        RankingNotStartedComponent,
        RankingEntryComponent], imports: [CommonModule, CommonsComponentModule, CommonsLocationModule, TranslationModule, PremiumModule], exports: [RankingMemberEntryComponent,
        RankingMembersComponent,
        RankingContestantComponent,
        RankingRoundPickerComponent,
        RankingGroupPickerComponent,
        RankingMatchComponent,
        RankingSwitcherComponent,
        RankingMatchSkeletonComponent,
        RankingMemberEntrySkeletonComponent,
        RankingContestantSkeletonComponent,
        RankingMembersSkeletonComponent,
        RankingSwitcherSkeletonComponent,
        RankingNotStartedComponent,
        RankingEntryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, CommonsComponentModule, CommonsLocationModule, TranslationModule, PremiumModule],
                declarations: [
                    RankingMemberEntryComponent,
                    RankingMembersComponent,
                    RankingContestantComponent,
                    RankingRoundPickerComponent,
                    RankingGroupPickerComponent,
                    RankingMatchComponent,
                    RankingSwitcherComponent,
                    RankingMatchSkeletonComponent,
                    RankingMemberEntrySkeletonComponent,
                    RankingContestantSkeletonComponent,
                    RankingMembersSkeletonComponent,
                    RankingSwitcherSkeletonComponent,
                    RankingNotStartedComponent,
                    RankingEntryComponent,
                ],
                exports: [
                    RankingMemberEntryComponent,
                    RankingMembersComponent,
                    RankingContestantComponent,
                    RankingRoundPickerComponent,
                    RankingGroupPickerComponent,
                    RankingMatchComponent,
                    RankingSwitcherComponent,
                    RankingMatchSkeletonComponent,
                    RankingMemberEntrySkeletonComponent,
                    RankingContestantSkeletonComponent,
                    RankingMembersSkeletonComponent,
                    RankingSwitcherSkeletonComponent,
                    RankingNotStartedComponent,
                    RankingEntryComponent,
                ],
            }]
    }], null, null); })();

class RankingModule {
}
RankingModule.ɵfac = function RankingModule_Factory(t) { return new (t || RankingModule)(); };
RankingModule.ɵmod = i0.ɵɵdefineNgModule({ type: RankingModule });
RankingModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, SvgIconsModule, CommonsErrorModule, CommonsLoadingModule, TranslationModule, RankingComponentsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RankingModule, { imports: [CommonModule, SvgIconsModule, CommonsErrorModule, CommonsLoadingModule, TranslationModule, RankingComponentsModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RankingModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, SvgIconsModule, CommonsErrorModule, CommonsLoadingModule, TranslationModule, RankingComponentsModule],
            }]
    }], null, null); })();

/*
 * Public API Surface of ranking
 */

/**
 * Generated bundle index. Do not edit.
 */

export { RankingComponentsModule, RankingContestantComponent, RankingContestantSkeletonComponent, RankingEntryComponent, RankingGroupPickerComponent, RankingMatchComponent, RankingMatchSkeletonComponent, RankingMemberEntryComponent, RankingMemberEntrySkeletonComponent, RankingMembersComponent, RankingMembersSkeletonComponent, RankingModule, RankingNotStartedComponent, RankingRoundPickerComponent, RankingSwitcherComponent, RankingSwitcherSkeletonComponent, rankingContestantTexts, rankingGroupPickerTexts, rankingMatchTexts, rankingMemberEntryTexts, rankingMembersText, rankingNotStartedTexts, rankingRoundPickerTexts, rankingSwitcherTexts };
//# sourceMappingURL=play-ranking.js.map
